// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"224":"35f36427","302":"aa8954e0","322":"9a48f18c","505":"9b388c47","596":"9ae3e6c3","687":"a7d77a9c","728":"fef71b9a","929":"13c899a5","932":"4a457840"}[chunkId] + ".js";
};